import React, { useContext } from 'react';
import ReactDOM from 'react-dom';

//component
import AllUsersScreen from  '@/components/page/OrgSettings/Users/AllUsers/AllUsersScreen';
import { OrgSettingsContext } from '@/context/OrgSettings';



const AllUsersPortal = () => {    
    const { setOrgId } = useContext(OrgSettingsContext);
    const targetContainer = document.getElementById('react-all-users-container');
    
    if (!targetContainer) {
        return null;
    } else {
        setOrgId(targetContainer.getAttribute('data-org-id'))
    }

    return ReactDOM.createPortal(
        <AllUsersScreen />, targetContainer
    );
}


export default AllUsersPortal;